import auth from "../../../../../Auth";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import Skeleton from "react-loading-skeleton";
import { IDropDownModel } from "../../../../../Shared/Models/IDropDownModel";
import { initialDataState } from "../../../../../ContentLibrary/ViewContentLibrary/ViewContentLibrary";
import CommonInfoMultiselect, { ALLSELECTED } from "../../../../ClientAdmin/OnBoardingConfiguration/CreateOnBoardingConfiguration/CommonInfoMultiselect";

export interface CandidateShareProps {
    message: any;
    vendorId: any;
    props: any;
    handleYes: any;
    handleNo: any;
}

export interface CandidateShareState {
    candidateId: string;
    clientName: string;
    divisionIds: string[];
    divisions: Array<IDropDownModel>;
    locationIds: [];
    showLoader?: boolean;
    submitted: boolean;
    dataState: any,
    locations: [],
    selectedDivisions: any;
    isAllDivSelected: boolean;
    selectedLocations: any;
    isAllLocSelected: boolean;
    isLocNotRequired,
    isDivNotRequired,
    clientId?: string;
    selectedLocs: any;
}

class CandidateShare extends React.Component<CandidateShareProps, CandidateShareState> {
    public rateCardChild: any;

    constructor(props: CandidateShareProps) {
        super(props);
        this.state = {
            candidateId: "",
            clientName: auth.getClientName(),
            divisionIds: [],
            divisions: [],
            locationIds: [],
            showLoader: false,
            submitted: false,
            dataState: initialDataState,
            locations: [],
            isAllLocSelected: true,
            isAllDivSelected: true,
            isLocNotRequired:true,
            isDivNotRequired:true,
            selectedDivisions: [],
            selectedLocations: [],
            selectedLocs: [],
            clientId: auth.getClient()
        };
    }

    componentDidMount() {
    }

   
    handleCreate() {
        this.setState({ submitted: true });

        this.props.handleYes({
            divisionId: this.state.divisionIds == null || this.state.divisionIds.length == 0 || this.state.divisionIds.findIndex((x: any) => x.id == 9999) > -1 ? null : this.state.divisionIds.filter((x: any) => x.id != 9999).map((m: any) => m.id),
            locationIds: (this.state.selectedDivisions == null || this.state.selectedDivisions.length == 0 || this.state.isAllDivSelected)
                && (this.state.isAllLocSelected || this.state.selectedLocs == null || this.state.selectedLocs.length == 0) ? null : this.state.isAllLocSelected ? this.state.selectedLocs.filter((x) => x.clientDivLocIntId != 9999).map((m) => m.id) : this.state.selectedLocs.map((m: any) => m.id)
        });
    }


    handleObjChange = (change) => {
        change["isDirty"] = true;
        this.setState(change);
    };

    handleDropdownChange = (e) => {
        console.log(e);
    };

    render() {
        const controlsToShow = ['DIVISION', 'LOCATION']

        const {
            clientId,
            selectedDivisions,
            selectedLocations,
            isAllDivSelected,
            isAllLocSelected,
            isLocNotRequired,
            isDivNotRequired,
            selectedLocs
        } = this.state;
        const commonInfo = {
            clientId,
            selectedDivisions,
            selectedLocations,
            isAllDivSelected,
            isAllLocSelected,
            isLocNotRequired,
            isDivNotRequired
        };
        return (
            <div className="row mx-0 mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            {"Candidate Share"}
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.handleNo}>
                            &times;
                        </button>
                    </div>
                    <div className="row text-left mx-0">
                        <div className="col-12 text-dark mt-3 px-4  pb-4">{this.props.message}</div>
                    </div>
                    {this.state.showLoader &&
                        Array.from({ length: 2 }).map((item, i) => (
                            <div className="row mx-auto mt-2" key={i}>
                                {Array.from({ length: 2 }).map((item, j) => (
                                    <div className="col-12 col-sm-6 col-lg-6 mt-sm-0  mt-1" key={j}>
                                        <Skeleton width={230} />
                                        <Skeleton height={30} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    {!this.state.showLoader && (
                        <div className="px-4 pt-0">
                            <div className="col-12 col-md-12 two-control-size px-0">
                          
                                    <CommonInfoMultiselect
                                        ref={(instance) => {
                                            this.rateCardChild = instance;
                                        }}
                                        data={commonInfo}
                                        Id={null}
                                        handleObjChange={this.handleObjChange}
                                        handleDropdownChange={this.handleDropdownChange}
                                        formikProps={null}
                                        controlsToShow={controlsToShow}
                                        isTagsAllowed={false}
                                        page="CandidateShare"

                                    />
                            </div>

                        </div>
                    )}

                    <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.handleNo}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                            <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={(e) => this.handleCreate()}>
                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Create
                            </button>
                        </div>

                    </div>
                </div>
            </div >
        );
    }
}
export default CandidateShare;